const estado = {
  access_token: null,
  user: null,
  rotaAtual: null,
  menuItems: null,
  ip: null,
  menuItemsRotas: null,
  mostraMenu: true,
  filtroRdv: null,
  filtroTelemetria: null,
  me: null,
  filtroTomador: null,
  notificacao: null,
  rdvCooperado: null,
  veiculoCooperado: [],
  debug: false,
  termoLgpd: false,
  termoAssembleia: null,
  validaTermoAssembleia: false,
  assinaturaEletronica: false,
  infoBancaria: false,
  telEmergencia: false,
  aceiteFiliacao: false,
  eSocial: false,
  cadastroClienteAstec: null,

  assinaturaConselho: false,
  assinaturasPendentesConselho: 0,
}
const getters = {
  usuarioEstaLogado: state => Boolean(state.access_token),
  menuItensexiste: state => Boolean(state.menuItems),
  assinaturasPendentesConselho: state => state.assinaturasPendentesConselho,
}

export {
  estado,
  getters
}
